import { selectState } from 'dg-web-shared/lib/Flux';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { SlideIn } from '../../ui/slidein/SlideIn';
import * as TransactionsListState from '../state/TransactionsListState';
import { PermitDetailFetching } from './Permit';

export const PermitDetailSlideIn = selectState(
    store => {
        const transactionsListDetail = TransactionsListState.Detail.get(store);

        return {
            transactionsListDetail,
            permitDetail: transactionsListDetail.permitExternalId
                ? TransactionsListState.PermitDetail.get(store, {
                      contractExternalId:
                          transactionsListDetail.permitExternalId,
                  })
                : null,
        };
    },
    props => (
        <SlideIn
            title={
                <Localized
                    de="Bewilligung"
                    fr="Autorisation"
                    it="Autorizzazione"
                    en="Permit"
                />
            }
            open={!!props.transactionsListDetail.permitExternalId}
            onClose={() => {
                props.update(store =>
                    TransactionsListState.Detail.stateWrite(store, {
                        permitExternalId: null,
                    }),
                );
            }}
        >
            {!!props.permitDetail && (
                <PermitDetailFetching
                    permitDetail={props.permitDetail}
                    renewalIsOkInCurrentContext={true}
                />
            )}
        </SlideIn>
    ),
);
